import { AccordeonFieldsFragment } from 'api/graphql-types';
import { IXMLSidebarData } from 'utils/aws-s3-helper';
import { sanitizeAndParseHtml } from 'utils/rich-text-renderer/sanitize-and-parse';
import Accordeon from 'modules/accordeon/accordeon-module';
import { AccordionSidebar, IAccordionSidebarProps } from './accordion-sidebar';
import styles from './accordion-list.module.scss';

export interface IAccordionListProps extends Omit<IAccordionSidebarProps, 'sidebar'> {
	titel?: string;
	description?: string;
	datum?: string;
	accordion?: AccordeonFieldsFragment;
	sidebar?: IXMLSidebarData;
	expandableSections?: boolean;
}

export const AccordionList = ({
	titel,
	accordion,
	sidebar,
	slug,
	description,
	expandableSections,
	...rest
}: IAccordionListProps): React.JSX.Element => {
	const parsedHtml = sanitizeAndParseHtml(description || '', true);

	return (
		<div className={styles.wrapper}>
			<div>
				{titel && <h2>{titel}</h2>}
				{description && <div>{parsedHtml}</div>}
				{accordion && <Accordeon expandableSections={expandableSections} module={accordion} hasTitle={!!titel} />}
			</div>

			{sidebar && <AccordionSidebar {...rest} sidebar={sidebar} slug={slug} />}
		</div>
	);
};

export default AccordionList;
